export default __webpack_public_path__ + "static/media/3.1d7468e0.webp";